import { Component, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCellComponent } from '@vendasta/galaxy/table';
import { FieldValueInterface } from '@vendasta/crm';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { StandardIds } from '../../../shared-services';
import { CrmTruncatePipe } from '../../../shared-pipes';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  template: `
    <div>
      <span>{{ body | crmTruncate: taskBodyLimit : true }}</span>
      @if (showTooltip) {
        <span [glxyTooltip]="body" [glxyTooltipDisabled]="isMobile()">...</span>
      }
    </div>
  `,
  imports: [CommonModule, GalaxyPipesModule, CrmTruncatePipe, GalaxyTooltipModule],
})
export class TaskBodyCellComponent extends CustomCellComponent {
  protected taskBodyLimit = 20;
  protected body = '';
  protected showTooltip = false;
  protected isMobile: Signal<boolean | undefined>;

  constructor(private breakpointObserver: BreakpointObserver) {
    super();
    this.isMobile = toSignal(
      this.breakpointObserver.observe([Breakpoints.XSmall]).pipe(map((result) => result.matches)),
    );
  }

  set value(newValues: (FieldValueInterface | null)[]) {
    const bodyField = newValues.filter(Boolean).find((field) => field?.fieldId === StandardIds.ActivityTaskBody);
    this.body = bodyField?.stringValue ? this.escapeHtml(bodyField.stringValue) : '';
    this.showTooltip = this.body.length > this.taskBodyLimit;
  }

  protected escapeHtml(html: string): string {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement.textContent || '';
  }
}
